import BandwagonAdapter from './bandwagon-adapter';
import EventReplicator from './event-replicator';

export default {
    BandwagonAdapter,
    EventReplicator,
};
